// AUTO-GENERATED SQL Builder (V40 Final) for BookingPackage
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingPackageSql {
  private ast = new SqlAst('BookingPackage', 'bookingPackage');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public vendorId: SqlField;
  public serviceCategoryId: SqlField;
  public name: SqlField;
  public amount: SqlField;
  public vendorCost: SqlField;
  public markup: SqlField;
  public status: SqlField;
  public offeringId: SqlField;
  public kind: SqlField;
  public eventSessionId: SqlField;
  public guests: SqlField;
  public offeringPackageId: SqlField;
  public extraHeads: SqlField;
  public isBundleHead: SqlField;
  public bundleOfferingId: SqlField;
  public bundleOfferingPackageId: SqlField;
  public bundleName: SqlField;
  public bundleTierName: SqlField;
  public ownServicesAmount: SqlField;
  public bundleMarkup: SqlField;
  public note: SqlField;
  public addonSelJson: SqlField;
  public bundleItemSelJson: SqlField;
  public booking: SqlNavHybrid;
  public bundleOffering: SqlNavHybrid;
  public bundleOfferingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringPackage: SqlNavHybrid;
  public serviceCategory: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public bookingDishSelectionList: SqlNavHybrid;
  public bookingItemSelectionList: SqlNavHybrid;
  public bookingMilestoneShareList: SqlNavHybrid;
  public bookingPackageItemQtyList: SqlNavHybrid;
  public bookingPackageLineList: SqlNavHybrid;
  public bookingPartnerChangeList: SqlNavHybrid;
  public invoiceLineList: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public partnerApprovalList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingPackage', 'guid', '', 'id', 'bookingPackage_guid');
    this.bookingId = new SqlField('bookingPackage', 'bookingId', 'booking', 'id', 'bookingPackage_booking');
    this.vendorId = new SqlField('bookingPackage', 'vendorId', 'vendor', 'id', 'bookingPackage_vendor');
    this.serviceCategoryId = new SqlField('bookingPackage', 'serviceCategoryId', 'serviceCategory', 'id', 'bookingPackage_serviceCategory');
    this.name = new SqlField('bookingPackage', 'name', '', 'id', 'bookingPackage_name');
    this.amount = new SqlField('bookingPackage', 'amount', '', 'id', 'bookingPackage_amount');
    this.vendorCost = new SqlField('bookingPackage', 'vendorCost', '', 'id', 'bookingPackage_vendorCost');
    this.markup = new SqlField('bookingPackage', 'markup', '', 'id', 'bookingPackage_markup');
    this.status = new SqlField('bookingPackage', 'status', '', 'id', 'bookingPackage_status');
    this.offeringId = new SqlField('bookingPackage', 'offeringId', 'offering', 'id', 'bookingPackage_offering');
    this.kind = new SqlField('bookingPackage', 'kind', '', 'id', 'bookingPackage_kind');
    this.eventSessionId = new SqlField('bookingPackage', 'eventSessionId', 'eventSession', 'id', 'bookingPackage_eventSession');
    this.guests = new SqlField('bookingPackage', 'guests', '', 'id', 'bookingPackage_guests');
    this.offeringPackageId = new SqlField('bookingPackage', 'offeringPackageId', 'offeringPackage', 'id', 'bookingPackage_offeringPackage');
    this.extraHeads = new SqlField('bookingPackage', 'extraHeads', '', 'id', 'bookingPackage_extraHeads');
    this.isBundleHead = new SqlField('bookingPackage', 'isBundleHead', '', 'id', 'bookingPackage_isBundleHead');
    this.bundleOfferingId = new SqlField('bookingPackage', 'bundleOfferingId', '', 'id', 'bookingPackage_bundleOffering');
    this.bundleOfferingPackageId = new SqlField('bookingPackage', 'bundleOfferingPackageId', '', 'id', 'bookingPackage_bundleOfferingPackage');
    this.bundleName = new SqlField('bookingPackage', 'bundleName', '', 'id', 'bookingPackage_bundleName');
    this.bundleTierName = new SqlField('bookingPackage', 'bundleTierName', '', 'id', 'bookingPackage_bundleTierName');
    this.ownServicesAmount = new SqlField('bookingPackage', 'ownServicesAmount', '', 'id', 'bookingPackage_ownServicesAmount');
    this.bundleMarkup = new SqlField('bookingPackage', 'bundleMarkup', '', 'id', 'bookingPackage_bundleMarkup');
    this.note = new SqlField('bookingPackage', 'note', '', 'id', 'bookingPackage_note');
    this.addonSelJson = new SqlField('bookingPackage', 'addonSelJson', '', 'id', 'bookingPackage_addonSelJson');
    this.bundleItemSelJson = new SqlField('bookingPackage', 'bundleItemSelJson', '', 'id', 'bookingPackage_bundleItemSelJson');
    this.booking = createNavHybrid('bookingPackage', 'bookingPackage_booking', 'Booking');
    this.bundleOffering = createNavHybrid('bookingPackage', 'bookingPackage_bundleOffering', 'Offering');
    this.bundleOfferingPackage = createNavHybrid('bookingPackage', 'bookingPackage_bundleOfferingPackage', 'OfferingPackage');
    this.createdByUser = createNavHybrid('bookingPackage', 'bookingPackage_createdByUser', 'User');
    this.eventSession = createNavHybrid('bookingPackage', 'bookingPackage_eventSession', 'EventSession');
    this.offering = createNavHybrid('bookingPackage', 'bookingPackage_offering', 'Offering');
    this.offeringPackage = createNavHybrid('bookingPackage', 'bookingPackage_offeringPackage', 'OfferingPackage');
    this.serviceCategory = createNavHybrid('bookingPackage', 'bookingPackage_serviceCategory', 'ServiceCategory');
    this.updatedByUser = createNavHybrid('bookingPackage', 'bookingPackage_updatedByUser', 'User');
    this.vendor = createNavHybrid('bookingPackage', 'bookingPackage_vendor', 'Vendor');
    this.bookingDishSelectionList = createNavHybrid('bookingPackage', 'bookingPackage_bookingDishSelectionList', 'BookingDishSelection');
    this.bookingItemSelectionList = createNavHybrid('bookingPackage', 'bookingPackage_bookingItemSelectionList', 'BookingItemSelection');
    this.bookingMilestoneShareList = createNavHybrid('bookingPackage', 'bookingPackage_bookingMilestoneShareList', 'BookingMilestoneShare');
    this.bookingPackageItemQtyList = createNavHybrid('bookingPackage', 'bookingPackage_bookingPackageItemQtyList', 'BookingPackageItemQty');
    this.bookingPackageLineList = createNavHybrid('bookingPackage', 'bookingPackage_bookingPackageLineList', 'BookingPackageLine');
    this.bookingPartnerChangeList = createNavHybrid('bookingPackage', 'bookingPackage_bookingPartnerChangeList', 'BookingPartnerChange');
    this.invoiceLineList = createNavHybrid('bookingPackage', 'bookingPackage_invoiceLineList', 'InvoiceLine');
    this.ledgerEntryList = createNavHybrid('bookingPackage', 'bookingPackage_ledgerEntryList', 'LedgerEntry');
    this.partnerApprovalList = createNavHybrid('bookingPackage', 'bookingPackage_partnerApprovalList', 'PartnerApproval');
    this.id = new SqlField('bookingPackage', 'id', '', 'id', 'bookingPackage_id');
    this.isDeleted = new SqlField('bookingPackage', 'isDeleted', '', 'id', 'bookingPackage_isDeleted');
    this.createdBy = new SqlField('bookingPackage', 'createdBy', '', 'id', 'bookingPackage_createdBy');
    this.createdDate = new SqlField('bookingPackage', 'createdDate', '', 'id', 'bookingPackage_createdDate');
    this.updatedBy = new SqlField('bookingPackage', 'updatedBy', '', 'id', 'bookingPackage_updatedBy');
    this.updatedDate = new SqlField('bookingPackage', 'updatedDate', '', 'id', 'bookingPackage_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingPackageSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingPackageSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingPackageSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
